import { all } from 'redux-saga/effects';
import getOnBoardingSaga from './getOnBoardingSaga';
import setOnBoardingSaga from './setOnBoardingSaga';

export default function* sectorModuleSaga() {
  yield all([setOnBoardingSaga(), getOnBoardingSaga()]);
}
